/**
 * Internal-navigation guard.
 *
 * يحمي صفحات المشغّل (/watch/$slug/$ep و /play) من المشاركة الخارجية:
 *   - عند نقر زر "شاهد" داخل صفحة المسلسل/الفيلم نستدعي allowNextInternalNav()
 *     فيُحفظ ختم زمني قصير العمر في sessionStorage.
 *   - عند تحميل صفحة المشغّل نستدعي consumeInternalNav(currentPath):
 *       • إن وُجد ختم حديث (<15s) → نُثبّت إذناً دائماً لهذا المسار في
 *         نفس التبويب (يسمح بالتحديث/الرجوع داخل نفس الجلسة) ونُرجع true.
 *       • إن سبق إعطاء إذن لهذا المسار في الجلسة → true.
 *       • غير ذلك → false (المستخدم وصل عبر رابط مُشارَك → يجب التحويل).
 *
 * sessionStorage مقصودة هنا: تبدأ من الصفر مع كل تبويب جديد، وهو
 * ما يجعل الروابط المشاركة على واتساب/تليجرام لا تجتاز الحارس.
 */
const STAMP_KEY = "rawan-nav-stamp";
const ALLOW_PREFIX = "rawan-nav-allow:";
const TTL_MS = 15_000;

export function allowNextInternalNav(): void {
  if (typeof window === "undefined") return;
  try { sessionStorage.setItem(STAMP_KEY, String(Date.now())); } catch { /* */ }
}

export function consumeInternalNav(currentPath: string): boolean {
  if (typeof window === "undefined") return true;
  try {
    // إذن سابق لنفس المسار في هذه الجلسة (تحديث/back/forward).
    if (sessionStorage.getItem(ALLOW_PREFIX + currentPath)) return true;
    const raw = sessionStorage.getItem(STAMP_KEY);
    sessionStorage.removeItem(STAMP_KEY);
    if (!raw) return false;
    const t = parseInt(raw, 10);
    if (!t || Date.now() - t > TTL_MS) return false;
    sessionStorage.setItem(ALLOW_PREFIX + currentPath, "1");
    return true;
  } catch {
    return true; // إذا تعذّر الوصول إلى التخزين لا نُعطّل الموقع.
  }
}
